import {
  c,
  cplusplus,
  csharp,
  java,
  python,
  scala,
  akka,
  ballerina,
  golang,
  javascript,
  css3,
  html5,
  nodejs,
  reactjs,
  vitejs,
  threejs,
  redux,
  tailwind,
  mongodb,
  mysql,
  postgresql,
  asgardeo,
  choreo,
  jenkins,
  docker,
  kubernetes,
  maven,
  linux,
  figma,
  git,
  unrealengine,
  unity,
  godot,
  adobeps,
  adobeillustrator,
  adobexd,
} from "../../assets";

export const TECHNOLOGIES = [
  {
    name: "C",
    icon: c,
  },
  {
    name: "C++",
    icon: cplusplus,
  },
  {
    name: "C#",
    icon: csharp,
  },
  {
    name: "Java",
    icon: java,
  },
  {
    name: "Python",
    icon: python,
  },
  {
    name: "Scala",
    icon: scala,
  },
  {
    name: "Akka",
    icon: akka,
  },
  {
    name: "Ballerina",
    icon: ballerina,
  },
  {
    name: "Golang",
    icon: golang,
  },
  {
    name: "JavaScript",
    icon: javascript,
  },
  {
    name: "CSS",
    icon: css3,
  },
  {
    name: "HTML",
    icon: html5,
  },
  {
    name: "NodeJS",
    icon: nodejs,
  },
  {
    name: "ReactJS",
    icon: reactjs,
  },
  {
    name: "ViteJS",
    icon: vitejs,
  },
  {
    name: "ThreeJS",
    icon: threejs,
  },
  {
    name: "Redux",
    icon: redux,
  },
  {
    name: "Tailwind",
    icon: tailwind,
  },
  {
    name: "MongoDB",
    icon: mongodb,
  },
  {
    name: "MySQL",
    icon: mysql,
  },
  {
    name: "PostgreSQL",
    icon: postgresql,
  },
  {
    name: "Asgardeo",
    icon: asgardeo,
  },
  {
    name: "Choreo",
    icon: choreo,
  },
  {
    name: "Jenkins",
    icon: jenkins,
  },
  {
    name: "Docker",
    icon: docker,
  },
  {
    name: "Kubernetes",
    icon: kubernetes,
  },
  {
    name: "Maven",
    icon: maven,
  },
  {
    name: "Linux",
    icon: linux,
  },
  {
    name: "Figma",
    icon: figma,
  },
  {
    name: "Git",
    icon: git,
  },
  {
    name: "Unreal Engine",
    icon: unrealengine,
  },
  {
    name: "Unity",
    icon: unity,
  },
  {
    name: "Godot",
    icon: godot,
  },
  {
    name: "Adobe Photoshop",
    icon: adobeps,
  },
  {
    name: "Adove Illustrator",
    icon: adobeillustrator,
  },
  {
    name: "Adobe XD",
    icon: adobexd,
  },
];
